import BaseApi from '@core/api/model';

export class SharedApi extends BaseApi {
    static resource = 'shared';

    get base_url() {
        return `/${this.constructor.version}`;
    }

    get endpoints() {
        return {
            getCurrentUser: this.getCurrentUser.bind(this),
            getPublicBranding: this.getPublicBranding.bind(this),
            getFileFromUrl: this.getFileFromUrl.bind(this),
            requestUpgrade: this.requestUpgrade.bind(this)
        };
    }

    async getCurrentUser() {
        return await BaseApi.api.get(`${this.base_url}/whoami`);
    }

    async getPublicBranding() {
        return await BaseApi.api.get(`${this.base_url}/public/branding`);
    }

    async getFileFromUrl(url) {
        return BaseApi.api.get(
            url,
            {},
            {
                responseType: 'blob',
                withCredentials: false
            }
        );
    }

    async requestUpgrade(message = null) {
        const payload = message ? { message } : {};
        payload.url = window.location.href;
        return await BaseApi.api.post(`${this.base_url}/request-upgrade`, payload);
    }
}

export default SharedApi;
